<template>
    <svg viewBox="0 0 36 36"
        class="fns ath-visual-score"
        :class="uiClass">
        <path d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
        <path v-if="!isEmpty"
            :stroke-dasharray="pct + ', 100'"
            d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
    </svg>
</template>

<script>
import { isNumber, isNumberBetween } from '@aretheyhappy/utils';

export default {
    name: 'mead-score',
    props: {
        /**
         * The score value used to draw the circular progress ring. When not a
         * number, the ring is rendered empty (no progress arc, "empty" style).
         */
        score       : {type: [Boolean, Number], default: () => 0},
        /**
         * The maximum possible value of `score`, used to compute the percentage
         * filled (`score / scale * 100`).
         */
        scale       : {type: Number, default: () => 100},
        /**
         * Use the "primary" brand color palette for the ring instead of the
         * default sentiment-based colors (positive/warning/negative).
         */
        primaryColor: {type: Boolean, default: () => false},
    },
    computed: {
        isEmpty: function () {
            return !isNumber(this.score);
        },
        pct: function () {
            if (this.isEmpty) return 0;
            return (this.score/this.scale) * 100;
        },
        // UI class generated based on primaryColor and the percentage value
        uiClass: function () {
            if (this.isEmpty) return 'empty';

            const prefix = this.primaryColor ? 'primary-' : '';
            let base = 'verybad';
            if (isNumberBetween(this.pct, 90, 100)) base = 'perfect';
            else if (isNumberBetween(this.pct, 80, 90)) base = 'good';
            else if (isNumberBetween(this.pct, 60, 80)) base = 'meh';
            else if (isNumberBetween(this.pct, 40, 60)) base = 'bad';

            return `${prefix}${base}`;
        },
    },
};
</script>

<style lang="scss" scoped>
@use '../../../../sass/variables' as *;

svg {
    display: block;
    width: 8rem;
    height: 8rem;
}

path:first-child {
    fill: none;
    stroke: var(--c-brand-light-bg);
    stroke-width: 2;
}

path:last-child {
    fill: none;
    stroke-width: 2;
    stroke-linecap: round;
    animation: progresscircle .5s ease-out forwards;
}

@mixin val ($name, $col) {
    .#{$name} path:last-child {
        stroke: $col;
    }
}

@include val('empty',           var(--c-brand-light-bg));
@include val('perfect',         var(--c-sentiment-positive-bg));
@include val('good',            var(--c-sentiment-positive-bg));
@include val('meh',             var(--c-sentiment-warning-bg));
@include val('bad',             var(--c-sentiment-negative-bg));
@include val('verybad',         var(--c-sentiment-negative-bg));
@include val('primary-perfect', #33D0D6);
@include val('primary-good',    #33D0D6);
@include val('primary-meh',     #99E7EB);
@include val('primary-bad',     #CCF3F5);
@include val('primary-verybad', #CCF3F5);
</style>
